export default "__VITE_ASSET__cGqygx_G__"